"use client";

import { Button } from "@/components";
import { getImageURL } from "@/lib";
import { useRef, useState } from "react";

export const HomePageInnovative = ({ data = {} }) => {
    const {
        right_description,
        description,
        title,
        subtitle,
        video,
        button,
        ["thumbnail-image"]: thumbnailImage,
    } = data;

    const videoRef = useRef();

    const [isPlaying, setIsPlaying] = useState(false);

    const handleActionClick = (action = "", value = "") => {
        switch (action) {
            case "play":
                videoRef?.current?.play();
                setIsPlaying(true);

                break;
            case "pause":
                videoRef?.current?.pause();
                setIsPlaying(false);

                break;
        }
    };

    const hasButtonContent =
        button && (button.title || button.url) ? true : false;

    return (
        <section className="innovative__section">
            <div className="custom-container">
                <div className="row">
                    <div className="col-12">
                        <div className="video__area">
                            <div
                                className="video__container"
                                onClick={() =>
                                    handleActionClick(
                                        isPlaying ? "pause" : "play"
                                    )
                                }
                            >
                                <div className="video__overlay" />
                                <video
                                    ref={videoRef}
                                    id="video-main"
                                    muted=""
                                    playsInline=""
                                    preload="metadata"
                                    poster={getImageURL(thumbnailImage?.src)}
                                    width="100%"
                                    height="auto"
                                >
                                    <source
                                        src={getImageURL(video?.src)}
                                        alt={video?.alt || "default alt text"}
                                    />
                                </video>
                                {!isPlaying && (
                                    <a
                                        href="javascript:void(0);"
                                        onClick={(e) => e.preventDefault()}
                                        className="play__btn_wrap"
                                    >
                                        <svg
                                            width={138}
                                            height={138}
                                            viewBox="0 0 138 138"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle
                                                opacity="0.25"
                                                cx={69}
                                                cy={69}
                                                r={69}
                                                fill="white"
                                            />
                                            <circle
                                                opacity="0.5"
                                                cx={69}
                                                cy={69}
                                                r={49}
                                                fill="white"
                                            />
                                            <circle
                                                cx={69}
                                                cy={69}
                                                r={28}
                                                fill="white"
                                            />
                                            <path
                                                d="M84 69L60.75 81.9904L60.75 56.0096L84 69Z"
                                                fill="#0DB02B"
                                            />
                                        </svg>
                                    </a>
                                )}
                            </div>
                            <div className="video__header">
                                <div
                                    className="heading"
                                    dangerouslySetInnerHTML={{
                                        __html: subtitle,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10 col-xl-10">
                        <div className="video__content text-center">
                            <div className="section_header">
                                <h3
                                    className="heading fs-48 fw-500"
                                    dangerouslySetInnerHTML={{
                                        __html: title,
                                    }}
                                />
                            </div>
                            <div className="content__wrap">
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: description,
                                    }}
                                />
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: right_description,
                                    }}
                                />
                            </div>
                            {hasButtonContent && (
                                <Button
                                    label={
                                        button?.title ||
                                        "Explore Our Innovations"
                                    }
                                    href={button?.url}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
